var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "intimate-rule" },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        style: `paddingTop:${_vm.barHeight}px`,
        attrs: { title: "", "left-arrow": "" },
        on: { "click-left": _vm.handleBack },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow05.png"),
                    alt: "",
                  },
                }),
                _c("span", { staticClass: "tit-left" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("lang.intimate.pageTitNew")) + " "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "prologue" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.prologue"))),
        ]),
        _c("div", { staticClass: "titie1" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.ruleTitle1"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.ruleText1"))),
        ]),
        _c("div", { staticClass: "titie2" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.ruleSubtitle1"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.ruleText2"))),
        ]),
        _c("div", { staticClass: "titie2" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.ruleSubtitle2"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.ruleText3"))),
        ]),
        _c("div", { staticClass: "titie1" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.ruleTitle2"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.ruleText4"))),
        ]),
        _c("div", { staticClass: "titie1" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.ruleText5"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.friendshipLevel.epilogue"))),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }